/* eslint-disable */
import throwParameterRequiredError from '../../../Errors/General/ParameterRequired.error';
import i18nIsLtr from '../../I18n/IsLtr/I18nIsLtr.support';

/**
 * Align the text to the ned
 * @export
 * @param {any} direction The direction used to determine if the align should be left or right
 * @returns {I18nEntityAlignments} The alignment
 */
const themeAlignEnd = (direction = throwParameterRequiredError(`direction`)) => (i18nIsLtr(direction) ? `right` : `left`);

export default themeAlignEnd;
